import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import RSVP from 'rsvp';
import { service } from '@ember/service';

export default Route.extend({
  fundsService: service(),
  navbarSettings: service(),
  storeCache: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Add Users to Fund');
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let fund = get(this.modelFor('admin.funds.fund'), 'record');
    let storeCache = this.storeCache;
    let promise = RSVP.hash({
      users: storeCache.findAll('admin/user'),
      indexUserFundsByFundId: storeCache.indexMultipleBy(
        'admin/user-fund',
        'fundId',
      ),
    });

    return promise.then((data) => {
      let fundUsers = data.indexUserFundsByFundId[get(fund, 'id')] || [];
      let fundUserIds = {};
      fundUsers.forEach((userFund) => {
        fundUserIds[get(userFund, 'userId')] = true;
      });
      return {
        fund: fund,
        items: data.users
          .filter((user) => {
            return !fundUserIds[get(user, 'id')];
          })
          .map((user) => {
            return {
              isSelected: false,
              user: user,
            };
          }),
        userFunds: data.indexUserFundsByFundId[get(fund, 'id')],
      };
    });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
